import { FaFire, FaChartLine, FaBullhorn, FaCrown, FaHome, FaBalanceScale, FaTrophy, FaRoad } from 'react-icons/fa';
import { FaArrowTrendUp, FaFaceFrownOpen, FaCircleXmark, FaRegChessKing, FaRoadCircleCheck } from 'react-icons/fa6';
import './About.css';

export default function About() {
  return (
    <div className="about-page">
    <h1>About HypeScore</h1>
    <p>
      <strong>HypeScore</strong> is a real-time momentum and hype engine that ranks MLB, NBA, and NHL teams using a custom scoring system driven by media sentiment, performance dominance, and playoff narratives.
    </p>

    <div className="about-highlight">
      ⚡ Built for edge-seekers, analysts, and fans who want to spot real momentum — before the standings catch up.
    </div>
    
    <h2>How It Works</h2>
    <p>The score updates constantly using these weighted factors:</p>

    <table className="about-table">
  <thead>
    <tr>
      <th>Signal</th>
      <th>Type</th>
      <th>Effect</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><FaArrowTrendUp /> <strong>Last 10 Wins</strong></td>
      <td>Bonus</td>
      <td>Recent winning record boosts momentum.</td>
    </tr>
    <tr>
      <td><FaFire /> <strong>Win Streak</strong></td>
      <td>Bonus</td>
      <td>Active win streaks create additional momentum (up to +15 points).</td>
    </tr>
    <tr>
      <td><FaChartLine /> <strong>Run Differential</strong></td>
      <td>Bonus</td>
      <td>Winning by large margins signals dominance (up to +3 points).</td>
    </tr>
    <tr>
      <td><FaFaceFrownOpen /> <strong>Injuries</strong></td>
      <td>Penalty</td>
      <td>Key player injuries apply penalties (up to –3 points).</td>
    </tr>
    <tr>
      <td><FaBullhorn /> <strong>Hype Mentions</strong></td>
      <td>Bonus</td>
      <td>Positive media coverage adds points (+3 per hit).</td>
    </tr>
    <tr>
      <td><FaCircleXmark /> <strong>Anti-Hype Mentions</strong></td>
      <td>Penalty</td>
      <td>Negative media stories deduct points (–8 per hit).</td>
    </tr>
    <tr>
      <td><FaCrown /> <strong>Elite</strong></td>
      <td>Bonus</td>
      <td>Top 10 standings, Top 10 run diff, or 80%+ playoff odds adds bonus hype.</td>
    </tr>
    <tr>
      <td><FaRegChessKing /> <strong>Division Leader</strong></td>
      <td>Bonus</td>
      <td>Teams leading their division (0 games back) earn bonus momentum (+5 points).</td>
    </tr>
    <tr>
      <td><FaBullhorn /> <strong>Underdog Wins</strong></td>
      <td>Bonus</td>
      <td>Teams winning against stronger opponents gain extra hype.</td>
    </tr>
    <tr>
      <td><FaHome /> <strong>Home Field Strength</strong></td>
      <td>Bonus</td>
      <td>Teams with strong home records (≥60% win rate) get a home advantage boost.</td>
    </tr>
    <tr>
      <td><FaRoadCircleCheck /> <strong>Road Warrior Strength</strong></td>
      <td>Bonus</td>
      <td>Teams with strong away records (≥60% win rate) are rewarded.</td>
    </tr>
    <tr>
      <td><FaBalanceScale /> <strong>Balanced Team</strong></td>
      <td>Bonus</td>
      <td>Teams with strong offense and defense (high points for, low points against) gain momentum.</td>
    </tr>
    <tr>
      <td><FaFaceFrownOpen /> <strong>Fatigue</strong></td>
      <td>Penalty</td>
      <td>Teams playing dense schedules (4+ games recently) suffer small penalties.</td>
    </tr>
    <tr>
      <td><FaTrophy /> <strong>Division Favorite</strong></td>
      <td>Bonus</td>
      <td>Teams with 50%+ division title odds earn respect points.</td>
    </tr>
    <tr>
      <td><FaRoad /> <strong>Wildcard Chaser</strong></td>
      <td>Bonus</td>
      <td>Teams with 30%+ wildcard odds receive a late-season hype bump.</td>
    </tr>
  </tbody>
</table>



    <h2>Why It’s Different</h2>
    <p>
      HypeScore isn't just about past records — it's about projecting who’s heating up or cooling off in real time. It blends performance, betting psychology, and media influence into one powerful signal.
    </p>
    <p>
      Track rising contenders, spot hidden threats, and get ahead of the public narrative.
    </p>

    <h2>Sources + Signals</h2>
    <p>
      Scores are calculated using data from ESPN, Google News sentiment analysis, team statistical trends, and real-time event triggers.
      Updates happen continuously throughout each day and during live games.
    </p>
  </div>
  );
}
